/** Same footer links as the main app sidebar (`AppNavigationLayout`). */
export const appFooterExternalLinks: { href: string; text: string }[] = [
  { href: "https://www.youtube.com/channel/UCJITEnFtWleIVvC-KTfTLjw", text: "Tutorials" },
  { href: "https://www.crowdcoursing.com/terms-of-use", text: "Terms of Use" },
  { href: "mailto:contact@crowdcoursing.com", text: "Email Support" },
];
